import script from "./supervisors.vue?vue&type=script&setup=true&lang=js"
export * from "./supervisors.vue?vue&type=script&setup=true&lang=js"

import "./supervisors.vue?vue&type=style&index=0&id=b330616c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b330616c"]])

export default __exports__